var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { MEDIA_QUERIES } from 'shared/style';
import Pagination from './Pagination';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: 50px 0;\n\n  > .area {\n    ", " {\n      max-width: 1200px;\n    }\n    ", " {\n      width: 100%;\n    }\n    padding: 0 10px;\n    margin: 0 auto;\n    overflow: auto;\n\n    > .tools {\n      width: 100%;\n      height: 70px;\n      margin-top: 20px;\n\n      > .search {\n        width: calc(100% - 100px);\n        float: left;\n      }\n\n      > .writing-btn {\n        width: 100px;\n        float: right;\n\n        > button {\n          all: unset;\n          box-sizing: border-box;\n          width: 100px;\n          height: 60px;\n          float: right;\n          text-align: center;\n          line-height: 60px;\n          margin-left: 5px;\n          font-size: 16px;\n          color: #fff;\n          background-color: #444;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"], ["\n  width: 100%;\n  margin: 50px 0;\n\n  > .area {\n    ", " {\n      max-width: 1200px;\n    }\n    ", " {\n      width: 100%;\n    }\n    padding: 0 10px;\n    margin: 0 auto;\n    overflow: auto;\n\n    > .tools {\n      width: 100%;\n      height: 70px;\n      margin-top: 20px;\n\n      > .search {\n        width: calc(100% - 100px);\n        float: left;\n      }\n\n      > .writing-btn {\n        width: 100px;\n        float: right;\n\n        > button {\n          all: unset;\n          box-sizing: border-box;\n          width: 100px;\n          height: 60px;\n          float: right;\n          text-align: center;\n          line-height: 60px;\n          margin-left: 5px;\n          font-size: 16px;\n          color: #fff;\n          background-color: #444;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.goToWriting = function (e) {
            e.preventDefault();
            var _a = _this.props, history = _a.history, match = _a.match;
            var urls = match.url.split('/');
            if (urls.length === 5) {
                urls.pop();
            }
            history.push(urls.join('/') + '/write');
        };
        return _this;
    }
    Footer.prototype.render = function () {
        var _a = this.props, currentPage = _a.currentPage, updatePage = _a.updatePage, totalPostCount = _a.totalPostCount, unit = _a.unit, writable = _a.writable;
        return (React.createElement(RootDiv, null,
            React.createElement("div", { className: "area" },
                totalPostCount
                    ? React.createElement(Pagination, { currentPage: currentPage, updatePage: updatePage, totalPostCount: totalPostCount, unit: unit })
                    : null,
                React.createElement("div", { className: "tools" },
                    React.createElement("div", { className: "search" }),
                    writable && React.createElement("div", { className: "writing-btn" },
                        React.createElement("button", { onClick: this.goToWriting }, "\uAE00\uC4F0\uAE30"))))));
    };
    Footer = __decorate([
        withRouter
    ], Footer);
    return Footer;
}(React.Component));
export default Footer;
var templateObject_1;
